import MethodActionGenerator from './MethodActionGenerator'

export default class DestroyActionGenerator extends MethodActionGenerator {
  constructor(name, basePath, parameterName) {
    super('DESTROY', name, basePath, parameterName)
  }

  mainActionGenerator = () => {
    return (id) => (dispatch) => {
      dispatch({ type: this.types.request, id })

      return this.client.delete(`${this.basePath}/${id}`)
        .then((response) => {
          return dispatch({
            type: this.types.response,
            responseHeaders: response.headers
          })
        })
        .catch((error) => dispatch({ type: this.types.error, ...this.parseError(error) }))
    }
  }
}
